// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"d5435bf3","377":"7d3ea15f","417":"c04f0609","467":"abb97107","626":"e5e40771","870":"c47d93aa"}[chunkId] + ".js";
};